import React, { useEffect, useState } from "react";

const FONT_SERIF = "'Fraunces', serif";
const FONT_SANS = "'Public Sans', sans-serif";

const IconPhone = (props) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" />
  </svg>
);

const IconMail = (props) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <rect x="2" y="4" width="20" height="16" rx="2" />
    <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
  </svg>
);

const IconWhatsapp = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38a9.9 9.9 0 0 0 4.74 1.2h.01c5.46 0 9.9-4.45 9.9-9.91 0-2.65-1.03-5.14-2.9-7.01A9.82 9.82 0 0 0 12.04 2Zm0 1.67c2.19 0 4.25.85 5.8 2.4a8.2 8.2 0 0 1 2.4 5.84c0 4.55-3.7 8.24-8.21 8.24a8.2 8.2 0 0 1-4.18-1.14l-.3-.18-3.12.82.83-3.04-.19-.31a8.17 8.17 0 0 1-1.25-4.37c0-4.55 3.71-8.26 8.22-8.26Zm-4.7 4.3c-.17 0-.44.06-.67.31-.23.25-.87.85-.87 2.07 0 1.22.89 2.4 1.01 2.56.13.17 1.75 2.78 4.31 3.79 2.13.85 2.57.68 3.03.64.46-.04 1.49-.6 1.7-1.19.21-.58.21-1.08.15-1.19-.06-.1-.23-.17-.48-.3-.25-.13-1.49-.74-1.72-.82-.23-.08-.4-.13-.57.13-.17.25-.65.82-.8.99-.15.17-.29.19-.54.06-.25-.13-1.06-.39-2.02-1.25-.75-.67-1.25-1.5-1.4-1.75-.15-.25-.02-.39.11-.51.11-.11.25-.29.38-.44.13-.15.17-.25.25-.42.08-.17.04-.31-.02-.44-.06-.13-.57-1.4-.79-1.91-.2-.5-.41-.43-.57-.44-.15-.01-.31-.01-.48-.01Z" />
  </svg>
);

const IconInstagram = (props) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <rect x="2" y="2" width="20" height="20" rx="5" />
    <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
    <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
  </svg>
);

const IconMenu = (props) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <line x1="4" y1="7" x2="20" y2="7" />
    <line x1="4" y1="12" x2="20" y2="12" />
    <line x1="4" y1="17" x2="20" y2="17" />
  </svg>
);

const IconX = (props) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

const IconScaleSmall = (props) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="m16 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z" />
    <path d="m2 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z" />
    <path d="M7 21h10" />
    <path d="M12 3v18" />
    <path d="M3 7h2c2 0 5-1 7-2 2 1 5 2 7 2h2" />
  </svg>
);

const IconBriefcase = (props) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <rect x="2" y="7" width="20" height="14" rx="2" />
    <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
    <path d="M2 13h20" />
  </svg>
);

const IconFamily = (props) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M17 21v-2a4 4 0 0 0-4-4H7a4 4 0 0 0-4 4v2" />
    <circle cx="10" cy="7" r="4" />
    <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
);

const FUEROS = [
  {
    art: "I",
    icon: IconScaleSmall,
    title: "Fuero Civil",
    desc: "Asesoramiento integral legal preliminar y evaluación de estrategias, tanto como parte actora o demandada. Daños y perjuicios, incumplimientos contractuales, accidentes de tránsito con y sin lesiones, reclamos de pasajeros transportados, reclamos ante compañías de seguros por incumplimiento de pólizas, ejecución de sentencias y juicios sucesorios.",
  },
  {
    art: "II",
    icon: IconBriefcase,
    title: "Fuero Comercial",
    desc: "Asesoramiento integral legal preliminar y evaluación de estrategias en acciones de daños derivadas de la Ley de Defensa del Consumidor dentro de procesos comerciales, incumplimiento y ejecución de contratos, juicios ejecutivos, y pedidos y levantamiento de quiebra e inhibiciones.",
  },
  {
    art: "III",
    icon: IconFamily,
    title: "Fuero de Familia",
    desc: "Representación tanto de parte actora como demandada en divorcios, cuidado personal, régimen de comunicación, plan de parentalidad, liquidación y disolución de la comunidad conyugal, consignación y cuota de alimentos, alimentos provisorios e incidentes, y acciones de filiación.",
  },
];

function SealEmblem({ name = "DANIEL M. SKARPONA" }) {
  const tickCount = 72;
  const ticks = Array.from({ length: tickCount });
  return (
    <svg viewBox="0 0 200 200" className="w-full h-full">
      <defs>
        <path
          id="sealTitleArc"
          d="M 34,104 A 66,66 0 0 1 166,104"
          fill="none"
        />
        <radialGradient id="sealGlow" cx="50%" cy="42%" r="55%">
          <stop offset="0%" stopColor="#fbbf24" stopOpacity="0.28" />
          <stop offset="100%" stopColor="#fbbf24" stopOpacity="0" />
        </radialGradient>
      </defs>

      <circle cx="100" cy="100" r="92" fill="url(#sealGlow)" />

      {ticks.map((_, i) => {
        const angle = (i / tickCount) * Math.PI * 2;
        const major = i % 6 === 0;
        const r1 = major ? 88 : 91;
        const r2 = 97;
        const x1 = 100 + r1 * Math.cos(angle);
        const y1 = 100 + r1 * Math.sin(angle);
        const x2 = 100 + r2 * Math.cos(angle);
        const y2 = 100 + r2 * Math.sin(angle);
        return (
          <line
            key={i}
            x1={x1}
            y1={y1}
            x2={x2}
            y2={y2}
            stroke="currentColor"
            strokeWidth={major ? 1.4 : 0.7}
            opacity={major ? 0.9 : 0.4}
          />
        );
      })}

      <circle
        cx="100"
        cy="100"
        r="82"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.3"
        opacity="0.85"
      />
      <circle
        cx="100"
        cy="100"
        r="74"
        fill="none"
        stroke="currentColor"
        strokeWidth="0.6"
        opacity="0.5"
      />

      <text
        fontSize="9.5"
        letterSpacing="2.2"
        fill="currentColor"
        style={{ fontFamily: "'Public Sans', sans-serif" }}
      >
        <textPath
          xlinkHref="#sealTitleArc"
          href="#sealTitleArc"
          startOffset="50%"
          textAnchor="middle"
        >
          {name}
        </textPath>
      </text>

      <line
        x1="70"
        y1="112"
        x2="92"
        y2="112"
        stroke="currentColor"
        strokeWidth="1"
        opacity="0.6"
      />
      <line
        x1="108"
        y1="112"
        x2="130"
        y2="112"
        stroke="currentColor"
        strokeWidth="1"
        opacity="0.6"
      />
      <circle cx="100" cy="112" r="2.2" fill="currentColor" opacity="0.85" />

      <g
        transform="translate(100,146) scale(2)"
        fill="none"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g transform="translate(-12,-12)">
          <path d="m16 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z" />
          <path d="m2 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z" />
          <path d="M7 21h10" />
          <path d="M12 3v18" />
          <path d="M3 7h2c2 0 5-1 7-2 2 1 5 2 7 2h2" />
        </g>
      </g>
    </svg>
  );
}

const PILLARS = [
  {
    num: "I.",
    title: "Trato directo",
    desc: "Habla con el abogado que lleva su caso, no con un intermediario.",
  },
  {
    num: "II.",
    title: "Especialización",
    desc: "Más de una década de trayectoria en seguros y responsabilidad civil por daños.",
  },
  {
    num: "III.",
    title: "Seguimiento real",
    desc: "Novedades del expediente comunicadas a medida que ocurren, sin que tenga que preguntar.",
  },
  {
    num: "IV.",
    title: "Primera consulta sin cargo",
    desc: "Una reunión inicial para evaluar el caso antes de definir cualquier paso.",
  },
];

const PROCESS = [
  {
    num: "01",
    title: "Consulta inicial",
    desc: "Escucho su situación y evalúo la viabilidad del caso en una primera reunión, sin cargo.",
  },
  {
    num: "02",
    title: "Análisis",
    desc: "Reviso antecedentes, documentación y las alternativas legales disponibles para su caso puntual.",
  },
  {
    num: "03",
    title: "Estrategia",
    desc: "Defino un plan de acción concreto, con tiempos estimados y honorarios informados por adelantado.",
  },
  {
    num: "04",
    title: "Resolución",
    desc: "Lo acompaño en cada instancia — extrajudicial o judicial — hasta alcanzar el mejor resultado posible.",
  },
];

const NAV_LINKS = [
  { href: "#areas", label: "Fueros" },
  { href: "#sobre-mi", label: "Sobre mí" },
  { href: "#proceso", label: "Cómo trabajo" },
  { href: "#contacto", label: "Contacto" },
];

function Eyebrow({ dark, children }) {
  return (
    <div
      className={`text-xs tracking-wide uppercase mb-4 ${dark ? "text-amber-400" : "text-amber-700"}`}
    >
      {children}
    </div>
  );
}

export default function App() {
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const preconnect1 = document.createElement("link");
    preconnect1.rel = "preconnect";
    preconnect1.href = "https://fonts.googleapis.com";
    const preconnect2 = document.createElement("link");
    preconnect2.rel = "preconnect";
    preconnect2.href = "https://fonts.gstatic.com";
    preconnect2.crossOrigin = "anonymous";
    const fontLink = document.createElement("link");
    fontLink.rel = "stylesheet";
    fontLink.href =
      "https://fonts.googleapis.com/css2?family=Fraunces:opsz,wght@9..144,300;9..144,400;9..144,500;9..144,600&family=Public+Sans:wght@400;500;600&display=swap";
    document.head.appendChild(preconnect1);
    document.head.appendChild(preconnect2);
    document.head.appendChild(fontLink);
    return () => {
      document.head.removeChild(preconnect1);
      document.head.removeChild(preconnect2);
      document.head.removeChild(fontLink);
    };
  }, []);

  return (
    <div
      className="min-h-screen bg-white text-slate-900"
      style={{ fontFamily: FONT_SANS }}
    >
      {/* Header */}
      <header className="sticky top-0 z-50 bg-slate-950 border-b border-slate-800">
        <div className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between">
          <a href="#top" className="flex flex-col leading-tight">
            <span
              className="text-lg text-white tracking-wide"
              style={{ fontFamily: FONT_SERIF }}
            >
              Dr. Daniel M. Skarpona
            </span>
            <span className="text-xs text-amber-400 mt-0.5">Abogado</span>
          </a>

          <nav className="hidden md:flex items-center gap-8">
            {NAV_LINKS.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="text-sm text-slate-300 hover:text-amber-400 border-b border-transparent hover:border-amber-400 pb-1 transition-colors"
              >
                {link.label}
              </a>
            ))}
          </nav>

          <div className="hidden md:flex items-center gap-6">
            <a
              href="https://www.instagram.com/danyskarpona/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
              className="text-slate-300 hover:text-amber-400 transition-colors"
            >
              <IconInstagram className="w-5 h-5" />
            </a>
            <a
              href="#contacto"
              className="bg-amber-400 hover:bg-amber-300 text-slate-950 text-sm font-medium px-5 py-2.5 rounded-sm transition-colors"
            >
              Consultar
            </a>
          </div>

          <button
            className="md:hidden text-slate-200"
            onClick={() => setMenuOpen((v) => !v)}
            aria-label="Abrir menú"
          >
            {menuOpen ? (
              <IconX className="w-5 h-5" />
            ) : (
              <IconMenu className="w-5 h-5" />
            )}
          </button>
        </div>

        {menuOpen && (
          <div className="md:hidden border-t border-slate-800 bg-slate-950 px-6 py-4 flex flex-col gap-4">
            {NAV_LINKS.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setMenuOpen(false)}
                className="text-sm text-slate-300"
              >
                {link.label}
              </a>
            ))}
            <a
              href="https://www.instagram.com/danyskarpona/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-sm text-slate-300"
            >
              <IconInstagram className="w-4 h-4" />
              Instagram
            </a>
            <a
              href="#contacto"
              onClick={() => setMenuOpen(false)}
              className="text-sm text-amber-400 font-medium"
            >
              Consultar
            </a>
          </div>
        )}
      </header>

      {/* Hero */}
      <section id="top" className="relative overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage:
              "url('https://images.unsplash.com/photo-1589994965851-a8f479c573a9?auto=format&fit=crop&w=1800&q=80')",
          }}
        />
        <div
          className="absolute inset-0"
          style={{
            background:
              "linear-gradient(100deg, rgba(2,6,23,0.96) 0%, rgba(2,6,23,0.88) 42%, rgba(2,6,23,0.65) 100%)",
          }}
        />
        <div className="relative max-w-6xl mx-auto px-6 py-20 md:py-28 grid md:grid-cols-[1.35fr_0.9fr] gap-14 items-start">
          <div>
            <Eyebrow dark>Ejercicio profesional independiente</Eyebrow>
            <h1
              className="text-4xl md:text-6xl leading-[1.08] max-w-[15ch] font-medium text-white"
              style={{ fontFamily: FONT_SERIF }}
            >
              Dr. Daniel Marcelo Skarpona
            </h1>
            <p className="mt-3 text-amber-400 uppercase tracking-widest text-sm">
              Abogado — Atención personalizada
            </p>
            <p className="mt-6 text-slate-400 max-w-[46ch] text-base md:text-lg">
              Especializado en derecho de seguros y en responsabilidad civil por
              daños y perjuicios desde hace más de una década. Asesoramiento en
              los fueros civil, comercial y de familia, con una estrategia clara
              de principio a fin.
            </p>
            <div className="mt-8 flex flex-wrap gap-4">
              <a
                href="#contacto"
                className="bg-amber-400 hover:bg-amber-300 text-slate-950 text-sm font-medium px-6 py-3.5 rounded-sm transition-colors"
              >
                Consultar mi caso
              </a>
              <a
                href="tel:+541162919336"
                className="border border-slate-600 text-slate-200 hover:border-amber-400 hover:text-amber-400 text-sm px-6 py-3.5 rounded-sm transition-colors"
              >
                Llamar ahora
              </a>
            </div>
          </div>

          <div className="hidden md:flex justify-end pt-2">
            <div
              className="w-60 h-60 md:w-72 md:h-72 text-amber-400 flex-shrink-0"
              style={{ transform: "rotate(-3deg)" }}
            >
              <SealEmblem />
            </div>
          </div>
        </div>
      </section>

      {/* Pillars */}
      <section className="bg-white border-b border-slate-200">
        <div className="max-w-6xl mx-auto px-6 py-14 grid grid-cols-2 md:grid-cols-4">
          {PILLARS.map((p, i) => (
            <div
              key={p.num}
              className={`px-0 md:px-6 py-6 md:py-0 border-slate-200 ${i === 0 ? "" : "md:border-l"} ${
                i >= 2 ? "border-t md:border-t-0" : ""
              }`}
            >
              <div
                className="text-sm mb-2 text-amber-700"
                style={{ fontFamily: FONT_SERIF }}
              >
                {p.num}
              </div>
              <h4
                className="text-base font-medium mb-2 text-slate-900"
                style={{ fontFamily: FONT_SERIF }}
              >
                {p.title}
              </h4>
              <p className="text-sm text-slate-500">{p.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Fueros */}
      <section
        id="areas"
        className="bg-slate-50 border-b border-slate-200 py-20 md:py-24"
      >
        <div className="max-w-6xl mx-auto px-6">
          <div className="flex flex-wrap justify-between items-end gap-6 mb-14">
            <div>
              <Eyebrow>Fueros de actuación</Eyebrow>
              <h2
                className="text-3xl md:text-4xl max-w-[20ch] leading-tight text-slate-900"
                style={{ fontFamily: FONT_SERIF }}
              >
                Tres fueros. Un mismo criterio: resolver con precisión.
              </h2>
            </div>
            <p className="text-slate-500 max-w-[38ch] text-sm">
              Representación tanto de parte actora como demandada, con
              evaluación de estrategias desde la primera consulta.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-6 md:gap-7 items-stretch">
            {FUEROS.map((fuero) => {
              const Icon = fuero.icon;
              return (
                <div
                  key={fuero.art}
                  className="group relative h-full overflow-hidden bg-slate-950 rounded-sm px-7 pt-8 pb-9 border border-slate-800 hover:border-amber-400/60 transition-colors duration-300"
                >
                  {/* top accent bar */}
                  <div className="absolute top-0 left-0 right-0 h-1 bg-amber-400 scale-x-0 group-hover:scale-x-100 origin-left transition-transform duration-300" />

                  {/* watermark numeral */}
                  <div
                    className="absolute -top-4 -right-2 text-8xl leading-none text-white select-none pointer-events-none"
                    style={{ fontFamily: FONT_SERIF, opacity: 0.06 }}
                    aria-hidden="true"
                  >
                    {fuero.art}
                  </div>

                  <div className="relative">
                    <div className="w-12 h-12 rounded-full border border-amber-400/50 flex items-center justify-center mb-6">
                      <Icon className="w-5 h-5 text-amber-400" />
                    </div>

                    <div className="text-xs tracking-widest uppercase text-amber-400 mb-2">
                      Fuero {fuero.art}
                    </div>
                    <h3
                      className="text-xl font-medium text-white mb-3"
                      style={{ fontFamily: FONT_SERIF }}
                    >
                      {fuero.title}
                    </h3>
                    <p className="text-slate-400 text-sm leading-relaxed">
                      {fuero.desc}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* About */}
      <section
        id="sobre-mi"
        className="bg-white border-b border-slate-200 py-20 md:py-24"
      >
        <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-[0.9fr_1.1fr] gap-12 md:gap-16">
          <div>
            <Eyebrow>Sobre mí</Eyebrow>
            <p
              className="text-2xl leading-snug max-w-[22ch] font-normal text-slate-900 mb-8"
              style={{ fontFamily: FONT_SERIF }}
            >
              El derecho es más útil cuando se explica con claridad y se ejerce
              con criterio.
            </p>
            <div
              className="w-full aspect-[4/5] rounded-sm bg-cover bg-center border border-slate-200"
              style={{
                backgroundImage:
                  "url('https://images.unsplash.com/photo-1505664194779-8beaceb93744?auto=format&fit=crop&w=1000&q=80')",
              }}
              role="img"
              aria-label="Biblioteca jurídica"
            />
          </div>
          <div>
            <p className="text-slate-600 text-lg leading-relaxed mb-4">
              Dr. Daniel Marcelo Skarpona, abogado egresado de la Universidad de
              Buenos Aires (UBA). Especializado desde hace más de una década en
              derecho de seguros y responsabilidad civil por daños y perjuicios.
            </p>
            <p className="text-slate-600 text-lg leading-relaxed">
              Atiendo personalmente cada consulta, desde la primera reunión
              hasta la resolución final.
            </p>

            <div className="mt-10 flex items-center gap-5">
              <span
                className="text-6xl md:text-7xl text-amber-700 leading-none"
                style={{ fontFamily: FONT_SERIF }}
              >
                10+
              </span>
              <span className="text-slate-500 text-sm leading-relaxed max-w-[24ch] border-l border-slate-200 pl-5">
                años de trayectoria en seguros y responsabilidad civil por daños
              </span>
            </div>

            <div className="mt-10 border-t border-slate-200 pt-8 grid sm:grid-cols-2 gap-x-8 gap-y-6">
              <div>
                <span className="block text-slate-500 text-sm mb-1">
                  Formación
                </span>
                <span className="block text-slate-800 text-base">
                  Abogado, Universidad de Buenos Aires (UBA)
                </span>
              </div>
              <div>
                <span className="block text-slate-500 text-sm mb-1">
                  Ejercicio
                </span>
                <span className="block text-slate-800 text-base">
                  Profesional independiente
                </span>
              </div>
              <div className="sm:col-span-2">
                <span className="block text-slate-500 text-sm mb-1">
                  Especialización
                </span>
                <span className="block text-slate-800 text-base">
                  Derecho de seguros y responsabilidad civil por daños y
                  perjuicios
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Process */}
      <section
        id="proceso"
        className="bg-slate-50 border-b border-slate-200 py-20 md:py-24"
      >
        <div className="max-w-6xl mx-auto px-6">
          <Eyebrow>Cómo trabajo</Eyebrow>
          <h2
            className="text-3xl md:text-4xl mb-12 text-slate-900"
            style={{ fontFamily: FONT_SERIF }}
          >
            Un proceso ordenado, de la primera consulta a la resolución.
          </h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 border-t border-l border-slate-200">
            {PROCESS.map((step) => (
              <div
                key={step.num}
                className="p-7 border-r border-b border-slate-200 bg-white"
              >
                <div
                  className="text-2xl mb-3 text-amber-700"
                  style={{ fontFamily: FONT_SERIF }}
                >
                  {step.num}
                </div>
                <h4
                  className="text-base font-medium mb-2 text-slate-900"
                  style={{ fontFamily: FONT_SERIF }}
                >
                  {step.title}
                </h4>
                <p className="text-sm text-slate-500">{step.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact */}
      <section
        id="contacto"
        className="relative overflow-hidden py-20 md:py-24"
      >
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage:
              "url('https://images.unsplash.com/photo-1589391886645-d51941baf7fb?auto=format&fit=crop&w=1800&q=80')",
          }}
        />
        <div
          className="absolute inset-0"
          style={{
            background:
              "linear-gradient(120deg, rgba(2,6,23,0.97) 0%, rgba(2,6,23,0.9) 55%, rgba(2,6,23,0.75) 100%)",
          }}
        />
        <div className="relative max-w-6xl mx-auto px-6 grid md:grid-cols-[1fr_0.9fr] gap-14 items-start">
          <div>
            <Eyebrow dark>Contacto</Eyebrow>
            <h2
              className="text-3xl md:text-4xl mb-4 text-white max-w-[16ch]"
              style={{ fontFamily: FONT_SERIF }}
            >
              Empecemos por su caso.
            </h2>
            <p className="text-slate-400 text-base max-w-[42ch]">
              Cuénteme brevemente su situación y me comunico para coordinar una
              primera consulta. También puede llamarme o escribirme
              directamente.
            </p>
          </div>

          <div>
            <div className="border-t border-slate-800">
              <div className="py-4 border-b border-slate-800 flex items-center gap-3">
                <IconPhone className="w-4 h-4 text-amber-400" />
                <div>
                  <span className="block text-xs text-slate-500">Teléfono</span>
                  <a
                    href="tel:+541162919336"
                    className="text-lg text-white"
                    style={{ fontFamily: FONT_SERIF }}
                  >
                    11 6291-9336
                  </a>
                </div>
              </div>
              <div className="py-4 border-b border-slate-800 flex items-center gap-3">
                <IconMail className="w-4 h-4 text-amber-400" />
                <div>
                  <span className="block text-xs text-slate-500">Email</span>
                  <a
                    href="mailto:daniels25@hotmail.com"
                    className="text-lg text-white"
                    style={{ fontFamily: FONT_SERIF }}
                  >
                    daniels25@hotmail.com
                  </a>
                </div>
              </div>
              <div className="py-4 border-b border-slate-800">
                <span className="block text-xs text-slate-500 mb-1">
                  Atención
                </span>
                <span className="text-sm text-slate-300">
                  Lunes a viernes, con turno previo
                </span>
              </div>
            </div>

            <div className="flex flex-wrap gap-3 mt-7">
              <a
                href="https://wa.me/541162919336"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 bg-amber-400 hover:bg-amber-300 text-slate-950 text-sm font-medium px-5 py-3 rounded-sm transition-colors"
              >
                <IconWhatsapp className="w-4 h-4" />
                Escribir por WhatsApp
              </a>
              <a
                href="https://www.instagram.com/danyskarpona/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 border border-slate-600 text-slate-200 hover:border-amber-400 hover:text-amber-400 text-sm font-medium px-5 py-3 rounded-sm transition-colors"
              >
                <IconInstagram className="w-4 h-4" />
                Instagram
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-slate-950 text-slate-400 pt-12 pb-8 border-t border-slate-800">
        <div className="max-w-6xl mx-auto px-6">
          <div className="grid md:grid-cols-3 gap-10 pb-10 border-b border-slate-800">
            <div>
              <span
                className="text-white text-lg"
                style={{ fontFamily: FONT_SERIF }}
              >
                Dr. Daniel M. Skarpona
              </span>
              <p className="text-sm text-slate-500 mt-3 max-w-[34ch]">
                Abogado. Especializado en derecho de seguros y responsabilidad
                civil por daños y perjuicios, con más de una década de
                trayectoria en los fueros civil, comercial y de familia.
              </p>
            </div>
            <div>
              <h4 className="text-white text-sm font-medium mb-4">Fueros</h4>
              <ul className="grid gap-2.5 text-sm">
                <li>
                  <a href="#areas" className="hover:text-amber-400">
                    Fuero Civil
                  </a>
                </li>
                <li>
                  <a href="#areas" className="hover:text-amber-400">
                    Fuero Comercial
                  </a>
                </li>
                <li>
                  <a href="#areas" className="hover:text-amber-400">
                    Fuero de Familia
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="text-white text-sm font-medium mb-4">Contacto</h4>
              <ul className="grid gap-2.5 text-sm">
                <li>
                  <a href="tel:+541162919336" className="hover:text-amber-400">
                    11 6291-9336
                  </a>
                </li>
                <li>
                  <a
                    href="mailto:daniels25@hotmail.com"
                    className="hover:text-amber-400"
                  >
                    daniels25@hotmail.com
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.instagram.com/danyskarpona/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:text-amber-400"
                  >
                    @danyskarpona
                  </a>
                </li>
                <li>
                  <a href="#contacto" className="hover:text-amber-400">
                    Lun. a vie., con turno previo
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className="flex flex-wrap justify-between gap-2 pt-6 text-xs text-slate-600">
            <span>
              © Dr. Daniel M. Skarpona. La información de este sitio tiene
              carácter general y no constituye asesoramiento legal formal.
            </span>
            <span>Sitio desarrollado a medida.</span>
          </div>
        </div>
      </footer>

      {/* Floating actions */}
      <div className="fixed bottom-6 right-6 z-50">
        <a
          href="https://wa.me/541162919336"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Escribir por WhatsApp"
          className="w-14 h-14 rounded-full flex items-center justify-center text-white shadow-lg hover:opacity-90 hover:scale-105 transition-transform"
          style={{ background: "#25D366" }}
        >
          <IconWhatsapp className="w-6 h-6" />
        </a>
      </div>
    </div>
  );
}
